const IOS_PATTERN = /iphone|ipad|ipod/i;
const ANROID_PATTERN = /android|webos|blackberry|iemobile|opera mini/i;

export type PlatformType = 'iOS' | 'Android' | 'Desktop';

export const detectPlatform = (): PlatformType => {
  // Need the `typeof` hack to safely handle SSR.
  // See: https://dev.to/vvo/how-to-solve-window-is-not-defined-errors-in-react-and-next-js-5f97
  const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : null;
  if (userAgent != null && IOS_PATTERN.test(userAgent)) {
    return 'iOS';
  } else if (userAgent != null && ANROID_PATTERN.test(userAgent)) {
    return 'Android';
  } else {
    return 'Desktop';
  }
};

export const isAppleDevice = () => {
  if (typeof window !== 'undefined') {
    return /Macintosh|iPhone|iPad|iPod/i.test(navigator.userAgent);
  }
  return false;
};
